// Safe entry boot: dynamically import early guard and main to surface import errors
(function () {
  const w = window as any;
  try {
    w.__APP_BOOT_STAGE = 'entry-start';
    (w.__BOOT_LOGS = w.__BOOT_LOGS || []).push('[Boot] entry start');
  } catch {}

  function showOverlay(message: string, detail?: string) {
    try {
      if (document.getElementById('boot-error-overlay')) return;
      const el = document.createElement('div');
      el.id = 'boot-error-overlay';
      el.style.position = 'fixed';
      el.style.inset = '0';
      el.style.zIndex = '999999';
      el.style.background = 'white';
      el.style.color = 'black';
      el.style.fontFamily = 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif';
      el.style.padding = '24px';
      el.style.overflow = 'auto';
      el.innerHTML =
        '<div style="max-width:840px;margin:0 auto">' +
        '<h1 style="font-size:20px;margin:0 0 8px 0">Falha ao iniciar o app</h1>' +
        '<p style="margin:0 0 12px 0">' + (message || 'Erro desconhecido') + '</p>' +
        '<pre style="white-space:pre-wrap;background:#f6f8fa;border:1px solid #e5e7eb;border-radius:8px;padding:12px;margin:0 0 12px 0">' + (detail || '') + '</pre>' +
        '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">' +
        '<button id="boot-reload-btn" style="padding:8px 12px;border:1px solid #d1d5db;border-radius:8px;background:#111827;color:white;cursor:pointer">Recarregar</button>' +
        '<span style="font-size:12px;color:#6b7280">Stage: ' + (w.__APP_BOOT_STAGE || 'desconhecido') + '</span>' +
        '</div>' +
        '</div>';
      document.body.appendChild(el);
      const btn = document.getElementById('boot-reload-btn');
      if (btn) btn.addEventListener('click', function(){ location.reload(); });
    } catch {}
  }

  Promise.resolve().then(async () => {
    // Try early guard
    try {
      (w.__BOOT_LOGS = w.__BOOT_LOGS || []).push('[Boot] importing ensureSingleReact');
      await import('/src/boot/ensureSingleReact.ts');
      w.__APP_BOOT_STAGE = 'ensure-ok';
      (w.__BOOT_LOGS = w.__BOOT_LOGS || []).push('[Boot] ensureSingleReact ok');
    } catch (e: any) {
      w.__APP_BOOT_STAGE = 'ensure-failed';
      (w.__BOOT_LOGS = w.__BOOT_LOGS || []).push('[Boot] ensureSingleReact failed: ' + (e?.message || e));
      showOverlay('Falha em ensureSingleReact.ts', e?.stack || e?.message || String(e));
      // Continue to try main.tsx anyway
    }

    // Try main app
    try {
      (w.__BOOT_LOGS = w.__BOOT_LOGS || []).push('[Boot] importing main.tsx');
      await import('/src/main.tsx');
      (w.__BOOT_LOGS = w.__BOOT_LOGS || []).push('[Boot] main.tsx imported');
    } catch (e: any) {
      w.__APP_BOOT_STAGE = 'main-import-failed';
      (w.__BOOT_LOGS = w.__BOOT_LOGS || []).push('[Boot] main.tsx import failed: ' + (e?.message || e));
      showOverlay('Falha ao importar main.tsx', e?.stack || e?.message || String(e));
    }
  });
})();